module.exports = __webpack_public_path__ + "img/ApprTemp1.a4347438.png";